export default __webpack_public_path__ + "static/media/loveInTheDark.d3dea471.jpg";